import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Star, Heart } from 'lucide-react';
const testimonials = [{
  initials: 'CR',
  name: 'Cecilia R.',
  loc: 'Mendoza',
  tier: 'MegaPack PRO + Sistema Clientes',
  text: 'El Prompt de Detección de Riesgos Fiscales me salvó la vida. Detecté una inconsistencia en el IVA de un cliente que podría haberle generado una inspección. Lo corregí antes de que ARCA lo vea. Ese solo prompt ya justificó toda la inversión.',
  color: 'bg-pink-600'
}, {
  initials: 'RM',
  name: 'Roberto M.',
  loc: 'Buenos Aires',
  tier: 'Contador de PyMEs',
  text: 'Subí mis honorarios promedio un 65% en dos meses usando el Protocolo de Aumento del Tomo 4. No perdí un solo cliente. Algunos hasta me agradecieron porque entendieron mejor el valor de lo que reciben.',
  color: 'bg-blue-600'
}, {
  initials: 'SC',
  name: 'Sofía C.',
  loc: 'La Plata',
  tier: 'Estudio Unipersonal',
  text: 'Mis clientes de monotributo ahora reciben un reporte mensual de gestión. Nadie me volvió a decir que era caro. El reporte lo armo en 15 minutos con el prompt del Tomo 2 y parece hecho por una Big Four.',
  color: 'bg-purple-600'
}, {
  initials: 'PA',
  name: 'Pablo A.',
  loc: 'Neuquén',
  tier: 'Contador Independiente',
  text: 'La macro de conciliación bancaria fue un antes y un después. Lo que me llevaba 2 horas todos los viernes ahora lo hace el Excel solo en 40 segundos. Recuperé mis viernes por la tarde.',
  color: 'bg-emerald-600'
}, {
  initials: 'JM',
  name: 'Julia M.',
  loc: 'Rosario',
  tier: 'Contadora',
  text: 'El Kit de Bienvenida para clientes cambió la dinámica de mi estudio. Mis clientes ahora suben PDFs a Drive antes del día 5. Cerré el mes sin una sola foto borrosa por WhatsApp. Es un milagro.',
  color: 'bg-amber-700'
}];
export function MoreTestimonials() {
  return <section className="py-20" data-id="element-233">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-234">
        <FadeIn className="text-center mb-12" data-id="element-235">
          <div className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-4" data-id="element-236">
            <Heart className="w-6 h-6 text-red-500" data-id="element-237" />
          </div>
          <h2 className="text-3xl font-bold" data-id="element-238">
            MÁS CONTADORES QUE YA LO TIENEN
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-239">
          {testimonials.map((t, i) => <FadeIn key={i} delay={i * 0.1} className={`bg-brand-card border border-slate-800 p-6 rounded-2xl ${i === testimonials.length - 1 ? 'md:col-span-2 md:max-w-2xl md:mx-auto' : ''}`} data-id="element-240">
              <div className="flex items-center gap-1 mb-4" data-id="element-241">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-brand-accent text-brand-accent" data-id="element-242" />)}
              </div>
              <p className="text-slate-300 mb-6 italic leading-relaxed" data-id="element-243">
                "{t.text}"
              </p>
              <div className="flex items-center gap-3 mt-auto pt-4 border-t border-slate-800/50" data-id="element-244">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-white shrink-0 ${t.color}`} data-id="element-245">
                  {t.initials}
                </div>
                <div data-id="element-246">
                  <div className="font-bold text-sm text-white" data-id="element-247">
                    {t.name}{' '}
                    <span className="text-slate-400 font-normal" data-id="element-248">
                      📍 {t.loc}
                    </span>
                  </div>
                  <div className="text-xs text-brand-accent" data-id="element-249">{t.tier}</div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}